export const LABELS = {
  APPLICATION_NO: "申請番号",
  APPLICATION_DATE: "申請日",
  COMPANY_NAME: "事業者名",
  CORPORATE_NUMBER: "法人番号",
  INDUSTRY: "業態",
  REP_NAME: "代表者名",
  MERCHANT_NAME: "加盟店名",
  REP_NAME_KANA_APPLICATION: "代表者名カナ（申請書）",
  REP_NAME_KANA_TSR: "代表者名カナ（TSR）",
  MERCHANT: "加盟店",
  APPLICANT_USER_TYPE: "申請者種別",
  APPLICANT_EMAIL: "申請者メールアドレス",
  INDIVIDUAL_HANDLING_REASON: "個別取扱事由",
  CONFIRMATION_RESULT: "確認結果",
  COMMENT: "コメント",
  RATE_CATEGORY: "料率カテゴリ",
  INDIVIDUAL_CONSULTATION_NO: "個別相談-No",
  INDIVIDUAL_CONSULTATION_BRANCH_NO: "個別相談-枝番",
  STORE: "店舗",
  BULK_CONFIRMATION_RESULT_OK: "一括確認結果OK",
  BULK_CONFIRMATION_RESULT_NG: "一括確認結果NG",
  STORE_NAME: "店舗名",
  SELECT: "選択",
  BLANK_LITTLE_LONG: "　　　　　　　　　　　　　　　　　　　",
  BLANK_MIDDLE_LONG: "　　　　　　　　　　　　　　　　　　　　　　　　　　　",
  BLANK_LONG:
    "　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　",
  BLANK_SUPER_LONG:
    "　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　　",
} as const;
export const COMMENT_MAX_LENGTH = 100;
export const DEFAULT_COMMENT = "総合的判断により、見送りとさせていただきます。";
export const REQUIRES_REP_CONFIRMATION = "05";

export const TARGET_REP_NAME_KANA_COLUMN_LIST = [
  "repNameKanaApplication",
  "repNameKanaTSR",
];
